import React, { useEffect } from 'react';
import { Col, Row} from 'react-bootstrap';
import * as yup from 'yup';
import SmartField from '../../../../rhf/smartfield';
import { Controller, useWatch } from 'react-hook-form';

export const GetDisenrollValidationSchema = (formValues,lookupData) => {
    const base = {
        disenrolledreason: yup.string().required("*Required"),
        disenrolledreasonother: yup.string().when('disenrolledreason', {
            is: (val) => lookupData.disenrolledreasons.filter(x => x.hasfollowup).map(x => x.id).includes(val),
            then: (schema) => schema.required('Required').typeError('Invalid'),
            otherwise: (schema) => schema.notRequired().nullable()
        }),
        disenroll365: yup.string().when('disenrolledreason', {
            is: (val) => lookupData.disenrolledreasons.filter(x => x.has365followup).map(x => x.id).includes(val),
            then: (schema) => schema.required('Required').typeError('Invalid'),
            otherwise: (schema) => schema.notRequired().nullable()
        }),
    }

    return base;
    
}

const DisenrolledFields = ({register,errors,control,resetField,lookupdata}) => {
    const disenrollVal = useWatch({
        control: control,
        name: 'disenrolledreason'
    });

    const disenroll365Val = useWatch({
        control: control,
        name: 'disenroll365'
    });

    const selectedDisenrollItem = lookupdata.disenrolledreasons.find(item => item.id === disenrollVal);
    const selectedDisenroll365Item = lookupdata.disenrolled365.find(item => item.id === disenroll365Val); 

    useEffect(() => {
        if(selectedDisenrollItem){
            if(!selectedDisenrollItem.hasfollowup){
                resetField('disenrolledreasonother',{defaultValue: ''});
            }

            if(!selectedDisenrollItem.has365followup){
                resetField('disenroll365',{defaultValue: ''});
            }

            if(!(selectedDisenrollItem?.haswaiverfollowup || selectedDisenroll365Item?.hasfollowup)){
                resetField('waiversaftermfp',{defaultValue: []});
            }
        }
        else{
            resetField('disenrolledreasonother',{defaultValue: ''});
            resetField('disenroll365',{defaultValue: ''});
            resetField('waiversaftermfp',{defaultValue: []});
        }
    },[selectedDisenrollItem,selectedDisenroll365Item,resetField])

    return(
        <>
            <Col xs={12}>
                <strong className="d-flex justify-content-center">Disenrolled Information</strong>
            </Col>
            <Col xs={12}>
                <SmartField
                    label='Reason for Participation End'
                    name='disenrolledreason'
                    type='select'
                    style={{width: '100%'}}
                    options={lookupdata.disenrolledreasons}
                    register={register}
                    errors={errors}
                />
            </Col>
            {
                selectedDisenrollItem?.hasfollowup
                &&
                    <Col xs={12}>
                        <SmartField
                            label='Reason for Participation End (Other)'
                            name='disenrolledreasonother'
                            type='text'
                            style={{width: '100%'}}
                            register={register}
                            errors={errors}
                        />
                    </Col>
            }
            {
                selectedDisenrollItem?.has365followup
                &&
                    <Col xs={12}>
                        <SmartField
                            label='Client has completed 365 days. NOW ENTER the Status of the clients move to new waiver.'
                            defaultOption='--Select Status--'
                            name='disenroll365'
                            type='select'
                            style={{width: '100%'}}
                            options={lookupdata.disenrolled365}
                            register={register}
                            errors={errors}
                        />
                    </Col>
            }
            {
                (selectedDisenrollItem?.haswaiverfollowup || selectedDisenroll365Item?.hasfollowup)
                &&
                    <fieldset>
                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Please select any waivers applicable to when MFP ends.</legend>
                        <Row>
                            <Controller
                                name='waiversaftermfp'
                                control={control}
                                render={({field}) => (
                                    <>
                                    {
                                        lookupdata.waivers.map((item) => (
                                            <Col key={item.id} xs={12} md={6}>
                                                <label>
                                                    <input
                                                        type='checkbox'
                                                        value={item.id}
                                                        checked={field.value.includes(item.id)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if(e.target.checked){
                                                                field.onChange([...field.value, value]);
                                                            }
                                                            else{
                                                                field.onChange(field.value.filter((s) => s !== value));
                                                            }
                                                        }}  
                                                    />
                                                    {item.name}
                                                </label>
                                            </Col>
                                        ))
                                    }
                                    </>
                                )}
                            />
                        </Row>
                    </fieldset>
            }
        </>
    )
}

export default DisenrolledFields;